import { Link } from 'react-router-dom';

const INK    = '#0d0d0d';
const BLUE   = '#1755f4';
const MUTED  = '#888';
const BORDER = '#e8e8e8';

const css = `
*{box-sizing:border-box}
.lp-legal{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;color:${INK};background:white;min-height:100vh}
.lp-legal a{text-decoration:none;color:inherit}
.lp-legal nav{position:sticky;top:0;z-index:100;background:rgba(255,255,255,0.97);backdrop-filter:blur(8px);border-bottom:1px solid ${BORDER};padding:0 48px;height:60px;display:flex;align-items:center;justify-content:space-between}
.lp-legal .logo{font-size:15px;font-weight:900;letter-spacing:2px;text-transform:uppercase;color:${INK}}
.lp-legal .logo span{color:${BLUE}}
.lp-legal footer{background:#0a0a0a;padding:32px 48px;display:flex;justify-content:space-between;align-items:center;font-size:11px;color:rgba(255,255,255,0.2);letter-spacing:0.5px}
`;

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '48px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <div style={{ width: '24px', height: '1px', background: INK }} />
        <span style={{ fontSize: '9px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: INK }}>
          {title}
        </span>
      </div>
      <div style={{ fontSize: '14px', color: '#444', lineHeight: 1.9 }}>
        {children}
      </div>
    </div>
  );
}

function P({ children, style }) {
  return <p style={{ marginBottom: '12px', ...style }}>{children}</p>;
}

export default function Impressum() {
  return (
    <div className="lp-legal">
      <style>{css}</style>

      <nav>
        <Link to="/" className="logo">IMMO<span>HQ</span></Link>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Link to="/login" style={{ fontSize: '12px', fontWeight: 600, background: 'none', border: `1px solid ${BORDER}`, padding: '8px 16px', color: INK }}>
            Anmelden
          </Link>
          <Link to="/register" style={{ fontSize: '12px', fontWeight: 700, background: INK, border: 'none', padding: '9px 20px', color: 'white' }}>
            Kostenlos starten
          </Link>
        </div>
      </nav>

      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '80px 48px' }}>

        {/* Page header */}
        <div style={{ marginBottom: '64px', borderBottom: `1px solid ${BORDER}`, paddingBottom: '48px' }}>
          <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '4px', textTransform: 'uppercase', color: MUTED, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ width: '32px', height: '1px', background: MUTED, display: 'inline-block' }} />
            Rechtliches
          </div>
          <h1 style={{ fontSize: '64px', fontWeight: 900, letterSpacing: '-4px', lineHeight: 1, color: INK, margin: 0 }}>
            Impressum
          </h1>
        </div>

        <Section title="Angaben gemäß § 5 TMG">
          <P><strong>Canel Sözer</strong></P>
          <P>Schuntertal 23<br />38108 Braunschweig<br />Deutschland</P>
        </Section>

        <Section title="Kontakt">
          <P>E-Mail: <a href="mailto:info@immohq.eu" style={{ color: BLUE, fontWeight: 600 }}>info@immohq.eu</a></P>
        </Section>

        <Section title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
          <P>Canel Sözer<br />Schuntertal 23<br />38108 Braunschweig</P>
        </Section>

        <Section title="Haftung für Inhalte">
          <P>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </P>
          <P>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </P>
        </Section>

        <Section title="Haftung für Links">
          <P>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
          </P>
          <P>
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </P>
        </Section>

        <Section title="Urheberrecht">
          <P>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </P>
          <P>
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </P>
        </Section>

        <Section title="Streitschlichtung">
          <P>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <span style={{ color: BLUE }}>https://ec.europa.eu/consumers/odr</span>.
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </P>
          <P>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </P>
        </Section>

        <div style={{ marginTop: '48px', paddingTop: '32px', borderTop: `1px solid ${BORDER}` }}>
          <Link to="/" style={{ fontSize: '12px', fontWeight: 700, color: MUTED, letterSpacing: '0.5px' }}>
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>

      <footer>
        <span>© 2025 IMMOHQ · Canel Sözer · Braunschweig</span>
        <div style={{ display: 'flex', gap: '24px' }}>
          <Link to="/impressum" style={{ color: 'rgba(255,255,255,0.4)' }}>Impressum</Link>
          <Link to="/datenschutz" style={{ color: 'rgba(255,255,255,0.2)' }}>Datenschutz</Link>
        </div>
      </footer>
    </div>
  );
}
